export const IntTempConfig = {
    label: 'Temperatura Interna/Temperatura Externa ',
    borderColor1: 'rgb(0, 121, 239)',
    backgroundColor1: 'rgba(0, 121, 239, 0.5)',
    borderColor2: 'rgba(0, 179, 52)',
    backgroundColor2: 'rgba(0, 179, 52, 0.5)',
    borderColor3: 'rgba(237, 142, 35)',
    backgroundColor3: 'rgba(237, 142, 35,  0.5)',
    borderColor4: 'rgba(158, 141, 8, 62)',
    backgroundColor4: 'rgba(158, 141, 8, 0.5)',
}

export const HumidityConfig = {
    label: 'Umidade',
    borderColor1: 'rgb(0, 121, 239)',
    backgroundColor1: 'rgba(0, 121, 239, 0.5)',
    borderColor2: 'rgba(0, 179, 52)',
    backgroundColor2: 'rgba(0, 179, 52, 0.5)',
    borderColor3: 'rgba(158, 141, 8, 62)',
    backgroundColor3: 'rgba(158, 141, 8, 0.5)',
}

export const MechanicalVibrationsConfig = {
    label: 'Vibração Mecânica',
    borderColor1: 'rgb(0, 121, 239)',
    backgroundColor1: 'rgba(0, 121, 239, 0.5)',
    borderColor2: 'rgba(0, 179, 52)',
    backgroundColor2: 'rgba(0, 179, 52, 0.5)',
}

export const Co2Config = {
    label: 'CO2',
    borderColor1: 'rgb(0, 121, 239)',
    backgroundColor1: 'rgba(0, 121, 239, 0.5)',
    borderColor2: 'rgba(0, 179, 52)',
    backgroundColor2: 'rgba(0, 179, 52, 0.5)',
    borderColor3: 'rgba(237, 142, 35)',
    backgroundColor3: 'rgba(237, 142, 35,  0.5)',
}

